/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {

    GetAllGroups,
    GetFactoriesByGroupID,
    CollectionCenterWiseTransaction,
    GetVCCFactoriesByGroupID
};
async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

//For only VCC type factories
async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function CollectionCenterWiseTransaction(operationEntityID, fromDate, toDate) {
    const response = await CommonGet('/api/CollectionCenterWiseTransaction/GetCollectionCenterWiseTransaction', 'operationEntityID=' + operationEntityID + '&fromDate=' + fromDate + '&toDate=' + toDate);
    return response.data;
}
